import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  DELETE_ITEM,
  EDIT_ITEM,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SAVE_REQUEST,
  SAVE_SUCCESS,
  SEARCH,
  GET_FILTER_REQUEST,
  GET_FILTER_SUCCESS,
  SAVE_RATING_REQUEST,
  DELETE_IMAGE,
  SAVE_IMAGES,
  SAVE_CHECKLIST_REQUEST
} from './client-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const getAllRequest = (typeList?: any) => {
  return {
    type: GET_ALL_REQUEST,
    typeList
  };
};

export const getAllSuccess = (payload: any) => {
  return {
    type: GET_ALL_SUCCESS,
    payload
  };
};

export const getFilterRequest = ({
  queryString = '',
  skip = 0,
  limit = 6,
  ...visitDaysParams
}: {
  queryString?: string;
  skip?: number;
  limit?: number;
  visitDays?: string;
}) => {
  return {
    type: GET_FILTER_REQUEST,
    queryString,
    skip,
    limit,
    ...visitDaysParams
  };
};

export const getFilterSuccess = ({ clients, skip, limit, hasMore }) => {
  return {
    type: GET_FILTER_SUCCESS,
    clients,
    skip,
    limit,
    hasMore
  };
};

export const getByIdRequest = (id: string, typeList?: string) => {
  return {
    type: GET_BY_ID_REQUEST,
    id,
    typeList
  };
};

export const getByIdSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const saveRequest = (id: any, payload: any, files?: any) => {
  return {
    type: SAVE_REQUEST,
    id,
    payload,
    files
  };
};

export const saveSuccess = async () => {
  return {
    type: SAVE_SUCCESS
  };
};

export const saveRating = (payload: any, clientExternalCode: string, isModal?: boolean) => {
  return {
    type: SAVE_RATING_REQUEST,
    payload,
    clientExternalCode,
    isModal
  };
};

export const saveChecklist = (payload: any, clientExternalCode: string, questionaryId: string) => {
  return {
    type: SAVE_CHECKLIST_REQUEST,
    payload,
    clientExternalCode,
    questionaryId
  };
};

export const deleteItem = (id: string, payload: any) => {
  return {
    type: DELETE_ITEM,
    id,
    payload
  };
};

export const editItem = (id: string, typeList?: string) => {
  return {
    type: EDIT_ITEM,
    id,
    typeList
  };
};

export const saveImages = (files: FileList) => {
  return {
    type: SAVE_IMAGES,
    files
  };
};

export const deleteImage = (imageUrl: string) => {
  return {
    type: DELETE_IMAGE,
    imageUrl
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: String) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryText?: String) => {
  return {
    type: SEARCH,
    queryText
  };
};
